/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( document ).on( 'click', '.video-results .blog__pagination button', function() {
        filterResults( getVideosFilters( $( this ).attr( 'data-value' ) ) );
      } );

      $( '.videos__mobile-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.filter-form' ).slideToggle();
      } );

      $( document ).on( 'change', '.filter-wrapper input', function() {
        filterResults( getVideosFilters() );
        updateBubbles();
      } );

      $( document ).on( 'submit', 'form', function( e ) {
        e.preventDefault();
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( '.filter-wrapper input' ).prop( 'checked', false );
        filterResults( getVideosFilters() );
        updateBubbles();
      } );

      function getVideosFilters( paged = 1 ) {
        $( '.clear-filters-wrapper' ).addClass( 'hidden' );
        $( 'button[data-taxonomy] .amount' ).text( '' );

        const args = {
          paged: paged,
          tax_query: {
            relation: 'OR',
          },
        };

        if ( $( 'input[name="ll_video_plastic_surgery"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const plasticSurgeries = [];

          $( 'input[name="ll_video_plastic_surgery"]:checked' ).each( function() {
            plasticSurgeries.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_plastic_surgery = {
            relation: 'OR',
            ll_video_plastic_surgery: {
              taxonomy: 'll_video_plastic_surgery',
              field: 'term_id',
              terms: plasticSurgeries,
            },
          };

          $( 'button[data-taxonomy="ll_video_plastic_surgery"] .amount' ).text( '(' + plasticSurgeries.length + ')' );
        }

        if ( $( 'input[name="ll_video_nonsurgical_aesthetics"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const aesthetics = [];

          $( 'input[name="ll_video_nonsurgical_aesthetics"]:checked' ).each( function() {
            aesthetics.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_nonsurgical_aesthetics = {
            relation: 'OR',
            ll_program_interest: {
              taxonomy: 'll_video_nonsurgical_aesthetics',
              field: 'term_id',
              terms: aesthetics,
            },
          };

          $( 'button[data-taxonomy="ll_video_nonsurgical_aesthetics"] .amount' ).text( '(' + aesthetics.length + ')' );
        }

        if ( $( 'input[name="ll_video_hair_restoration"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const restorations = [];

          $( 'input[name="ll_video_hair_restoration"]:checked' ).each( function() {
            restorations.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_hair_restoration = {
            relation: 'OR',
            ll_video_hair_restoration: {
              taxonomy: 'll_video_hair_restoration',
              field: 'term_id',
              terms: restorations,
            },
          };

          $( 'button[data-taxonomy="ll_video_hair_restoration"] .amount' ).text( '(' + restorations.length + ')' );
        }

        if ( $( 'input[name="ll_video_wellness"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const restorations = [];

          $( 'input[name="ll_video_wellness"]:checked' ).each( function() {
            restorations.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_wellness = {
            relation: 'OR',
            ll_video_wellness: {
              taxonomy: 'll_video_wellness',
              field: 'term_id',
              terms: restorations,
            },
          };

          $( 'button[data-taxonomy="ll_video_wellness"] .amount' ).text( '(' + restorations.length + ')' );
        }

        if ( $( 'input[name="ll_video_skincare"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const skincares = [];

          $( 'input[name="ll_video_skincare"]:checked' ).each( function() {
            skincares.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_skincare = {
            relation: 'OR',
            ll_video_skincare: {
              taxonomy: 'll_video_skincare',
              field: 'term_id',
              terms: skincares,
            },
          };

          $( 'button[data-taxonomy="ll_video_skincare"] .amount' ).text( '(' + skincares.length + ')' );
        }

        if ( $( 'input[name="ll_video_our_practice"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const ourPractice = [];

          $( 'input[name="ll_video_our_practice"]:checked' ).each( function() {
            ourPractice.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_video_our_practice = {
            relation: 'OR',
            ll_video_our_practice: {
              taxonomy: 'll_video_our_practice',
              field: 'term_id',
              terms: ourPractice,
            },
          };

          $( 'button[data-taxonomy="ll_video_our_practice"] .amount' ).text( '(' + ourPractice.length + ')' );
        }

        return args;
      }

      function filterResults( args = [] ) {
        $( '.filter-results, .filter-form' ).addClass( 'is-loading' );
        const data = {
          'args': args,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/videos/filter',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.filter-results' ).html( data.results );
            $( '.filter-results, .filter-form' ).removeClass( 'is-loading' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      function updateBubbles() {
        $( '.filter-bubbles' ).empty();

        $( 'input[type="checkbox"]:checked' ).each( function() {
          const checkboxId = $( this ).attr( 'id' );
          const termName = $( 'label[for="' + checkboxId + '"] span:last' ).text();

          const bubble = $( '<div class="filter-bubble"></div>' ).text( termName );

          const closeButton = $( '<button type="button" class="close-bubble">x</button>' );

          bubble.on( 'click', () => {
            $( this ).prop( 'checked', false );
            filterResults( getVideosFilters() );
            updateBubbles();
          } );

          bubble.append( closeButton );
          $( '.filter-bubbles' ).append( bubble );
        } );

        if ( $( '.filter-bubbles' ).children().length > 0 ) {
          $( '.filter-bubbles-wrapper' ).removeClass( 'hidden' );
          $( '.filter-bubbles-wrapper' ).addClass( 'flex' );
        } else {
          $( '.filter-bubbles-wrapper' ).addClass( 'hidden' );
          $( '.filter-bubbles-wrapper' ).removeClass( 'flex' );
        }
      }

      $( document ).on( 'change', '.filter-wrapper input', function() {
        updateBubbles();
        filterResults( getVideosFilters() );
      } );

      updateBubbles();
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'videos', COMPONENT );
} )( app );
